import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'kodit-divider',
  templateUrl: './divider.component.html',
  styleUrls: ['./divider.component.scss'],
})
export class DividerComponent implements OnInit {
  @Input()
  dividerLabel: string;
  @Input()
  useDirective: boolean = false;
  @Input()
  useMargins: boolean = true;
  @Input()
  useLabel: boolean = true;

  @Input() dividerClass: string = 'p-mt-2 p-mb-2';

  constructor() {}

  ngOnInit(): void {}
}
